const DailyReportOptions = {
  props: {
    disableSelectionOnClick: true
  }
};

export default DailyReportOptions;
